import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="flex justify-between items-center p-5 bg-[#f3f7f5] top-0 z-50">
      <div className="text-2xl font-bold">Rajeev Pandya</div>
      
      <button 
        className="text-3xl md:hidden focus:outline-none z-50"
        onClick={toggleMenu}
      >
        {menuOpen ? '✖' : '☰'} 
      </button>

      <nav className="hidden md:block">
        <ul className="flex space-x-6">
          <li><Link to="/" className="hover:text-gray-600">Home</Link></li>
          <li><Link to="/about" className="hover:text-gray-600">About Me</Link></li>
          <li><Link to="/featured" className="hover:text-gray-600">Featured</Link></li>
          <li><Link to="/contact" className="hover:text-gray-600">Contact</Link></li>
        </ul>
      </nav>

      {menuOpen && (
        <nav className="fixed top-0 left-0 w-full h-full bg-white flex flex-col items-center justify-center z-40">
          <ul className="space-y-6 text-2xl">
            <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
            <li><Link to="/about" onClick={toggleMenu}>About Me</Link></li>
            <li><Link to="/featured" onClick={toggleMenu}>Featured</Link></li>
            <li><Link to="/contact" onClick={toggleMenu}>Contact</Link></li>
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Header;
